import React, { useMemo, useState } from 'react';
import { DefaultTFuncReturn } from 'i18next';
import { FormikProps } from 'formik';
import DatePicker, { registerLocale } from 'react-datepicker';
import { clsx } from 'clsx';
import { ru } from 'date-fns/locale';

import Icon from 'components/icon/icon.component';
import { isEmpty } from 'utils/shared.utils';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './date-picker.module.scss';

interface IProps {
  name: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  formik?: FormikProps<any>;
  label?: DefaultTFuncReturn | string;
  disabled?: boolean;
}

registerLocale('ru', ru);

const DatePickerComponent: React.FC<IProps> = ({
  formik,
  name,
  label,
  value,
  onChange,
  disabled,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const getError: string | null = useMemo(() => {
    if (!formik?.errors) {
      return null;
    }

    return formik?.errors[name] as string;
  }, [formik, name]);

  return (
    <div
      className={clsx({
        [styles.datePicker]: true,
        [styles['datePicker--error']]: !!getError && formik?.touched[name],
        [styles['datePicker--success']]: !getError && formik?.touched[name],
        [styles['datePicker--focused']]: isFocused,
        [styles['datePicker--haveValue']]: !isEmpty(value),
      })}
    >
      <DatePicker
        name={name}
        selected={value}
        onChange={onChange}
        locale="ru"
        dateFormat="dd.MM.yyyy"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        disabled={disabled}
      />
      {label ? <label>{label}</label> : null}
      {formik?.touched[name] && !!getError && (
        <span className={styles['datePicker--error__message']} aria-label={getError}>
          <Icon name={'CircleAlert'} size={16} />
        </span>
      )}
      {!isEmpty(value) && (
        <button type="button" className={styles.datePicker__clear} onClick={() => onChange(null)}>
          <Icon name={'X'} size={16} />
        </button>
      )}
    </div>
  );
};

export default DatePickerComponent;
